<template>
  <router-view v-slot="{ Component }">
    <transition name="view" appear>
      <component :is="Component" />
    </transition>
  </router-view>
</template>
<script>
import { mapMutations } from 'vuex';
import {
  TEMPLATE_ALERT,
  CAPABILITY_MOBILE,
  CAPABILITY_APM,
} from '@/utils/constants';
export default {
  name: 'Alert',
  components: {},
  methods: {
    ...mapMutations('globalState/app', ['setCurrentCapability']),
    ...mapMutations('globalState/app', ['toggleMenu', 'setTemplate']),
  },
  mounted() {
    let route =
      this.$route.query.capability &&
      this.$route.query.capability.toLocaleLowerCase
        ? this.$route.query.capability.toLocaleLowerCase()
        : '';
    this.setTemplate(TEMPLATE_ALERT);
    if (route === CAPABILITY_MOBILE.toLocaleLowerCase()) {
      this.setCurrentCapability(CAPABILITY_MOBILE);
    } else this.setCurrentCapability(CAPABILITY_APM);
  },
};
</script>
